module.exports = __webpack_public_path__ + "img/wx.2afe1f1e.png";